import AwaitingCreditRating from './awaiting-credit-rating';

export default AwaitingCreditRating;